export const allExpenseHeadList = [
  { title: "SN" },
  {
    title: "User",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["user", "fullName"],
  },
  { title: "Amount", sortArrow: true, sortBy: "number", address: ["amount"] },
  { title: "Description" },
  { title: "Date", sortArrow: true, sortBy: "date", address: ["date"] },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Status", sortArrow: true, sortBy: "number", address: ["state"] },
  { title: "Action" },
];

export const pendingExpenseHeadList = [
  { title: "SN" },
  {
    title: "User",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["user", "fullName"],
  },
  { title: "Amount", sortArrow: true, sortBy: "number", address: ["amount"] },
  { title: "Description" },
  { title: "Date", sortArrow: true, sortBy: "date", address: ["date"] },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  {
    title: "Status",
  },
  { title: "Accept/Reject" },
  { title: "Action" },
];

export const checkHistoryList = [
  { title: "SN" },
  {
    title: "Name",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["user", "fullName"],
  },
  { title: "Amount", sortArrow: true, sortBy: "number", address: ["amount"] },
  { title: "Description" },
  { title: "Date", sortArrow: true, sortBy: "date", address: ["date"] },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Status", sortArrow: true, sortBy: "status", address: ["state"] },
  { title: "Action" },
];

export const loansHeadList = [
  { title: "SN" },
  {
    title: "User",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fullName"],
  },
  {
    title: "Amount",
    sortArrow: true,
    sortBy: "number",
    address: ["loanBalance"],
  },
  { title: "Supervisor" },
  { title: "Action" },
  { title: "History" },
];

export const visitsHeadList = [
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Machine ID",
    sortArrow: true,
    sortBy: "number",
    address: ["station", "machine", "id"],
  },
  {
    title: "Operator Phone",
  },
  {
    title: "Visit Date",
    sortArrow: true,
    sortBy: "date",
    address: ["visitedAt"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "fullName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "fullName"],
  },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Work Done" },
  { title: "Status", sortArrow: true, sortBy: "number", address: ["status"] },
  {
    title: "Action",
  },
];

export const visitPendingHeadList = [
  {
    title: "Site/ID",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Operator Phone",
  },
  {
    title: "Visit Date",
    sortArrow: true,
    sortBy: "date",
    address: ["visitedAt"],
  },
  {
    title: "Field Technician",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["fieldTechnician", "fullName"],
  },
  {
    title: "Supervisor",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["supervisor", "fullName"],
  },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  { title: "Work Done" },
  { title: "Action" },
];

export const machinesHeadList = [
  {
    title: "Machine ID",
    sortArrow: true,
    sortBy: "number",
    address: ["id"],
  },
  {
    title: "Site Name",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["station", "name"],
  },
  {
    title: "Category",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["category", "name"],
  },
  {
    title: "Automation",
  },
  { title: "Action" },
];
export const discardedCyHeadList = [
  {
    title: "Cylinder No.",
  },
  {
    title: "Size",
    sortArrow: true,
    sortBy: "number",
    address: ["size"],
  },
  {
    title: "Discard Reason",
    sortArrow: true,
    sortBy: "alphabetically",
    address: ["reasonForDiscard"],
  },
  {
    title: "Updated By",
    sortArrow: true,
    sortBy: "date",
    address: ["checkpointDetail", "updatedBy", "fullName"],
  },
  {
    title: "Updated At",
    sortArrow: true,
    sortBy: "date",
    address: ["checkpointDetail", "updatedAt"],
  },
  {
    title: "Action",
  },
];
